import { fancybox } from "@fancyapps/fancybox";
require('@fancyapps/fancybox/dist/jquery.fancybox.min.css');

//
// CONFIG
$.fancybox.defaults.transitionEffect = ["tube"];
$.fancybox.defaults.buttons          = ["zoom", "slideShow", "fullScreen", "thumbs", "close"];
$.fancybox.defaults.protect          = true;